import { IconProps } from "../../utils/global-types/global-types";

const QuestionandanswerIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M14.2897 6.89499V9.185C14.2897 11.32 12.5497 13.06 10.4147 13.06H7.96973C8.37473 13.435 8.91473 13.655 9.50473 13.655H12.1697L13.5647 14.535C13.6947 14.615 13.8447 14.655 13.9897 14.655C14.1247 14.655 14.2597 14.62 14.3797 14.555C14.6347 14.415 14.7897 14.145 14.7897 13.855V13.38C15.5247 12.985 15.9997 12.21 15.9997 11.36V9.11499C15.9997 8.04999 15.2747 7.14999 14.2897 6.89499Z"
      />
      <path
        fill="currentColor"
        d="M3.595 11.755V12.48C3.595 12.805 3.76999 13.105 4.05499 13.265C4.19 13.34 4.34 13.375 4.48999 13.375C4.655 13.375 4.82001 13.33 4.965 13.24L6.845 12.06H10.415C12 12.06 13.29 10.77 13.29 9.185V6.22C13.29 4.63498 12 3.345 10.415 3.345H4.875C3.29001 3.345 2 4.63498 2 6.22V9.185C2 10.285 2.63 11.275 3.595 11.755ZM7.655 10.45C7.38 10.45 7.155 10.23 7.155 9.94998C7.155 9.67499 7.375 9.44998 7.64999 9.44998H7.655C7.92999 9.44998 8.155 9.67499 8.155 9.94998C8.155 10.23 7.92999 10.45 7.655 10.45ZM6.63 5.30499C7.01999 4.995 7.53 4.88 8.02499 4.995C8.62 5.13 9.095 5.60498 9.23499 6.20499C9.39001 6.88 9.12 7.565 8.54501 7.94501C8.29999 8.10999 8.14499 8.41 8.14499 8.73999C8.14499 9.01498 7.92001 9.23999 7.64499 9.23999C7.37 9.23999 7.14499 9.01498 7.14499 8.73999C7.14499 8.07001 7.45999 7.45999 7.995 7.10999C8.215 6.965 8.32001 6.69501 8.26001 6.42999C8.20999 6.20499 8.02499 6.01999 7.79999 5.97C7.60001 5.92499 7.405 5.965 7.25 6.09C7.10001 6.20999 7.01501 6.38998 7.01501 6.58499C7.01501 6.85999 6.79001 7.08499 6.51501 7.08499C6.23499 7.08499 6.01501 6.85999 6.01501 6.58499C6.01501 6.08499 6.23999 5.62 6.63 5.30499Z"
      />
    </svg>
  );
};

export default QuestionandanswerIcon;
